import { Header } from "@usitsdasdesign/dds-react";
import { useSession } from "next-auth/react";
import { usePathname } from "next/navigation";
import { useRouter } from'hooks/navigation-router-with-loading'
import LayoutMainContainer from "organisms/LayoutMainContainer";
import SwitchProfile from "organisms/SwitchProfile";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import DelegateActivity from "../DelegateActivity";
import Delegates from "../Delegates";
import GuestRM from "../GuestRM";
import HeaderArguments from "../Helper/HeaderArguments";
import LoginBehalf from "../LoginBehalf";
import Notifications from "../Notifications";
import useClickOutside from "../useClickOutSide";

const UserLayout = ({ children }) => {
    const [showEdit, setShowEdit] = useState(false)
    const [isSwitchProfile, setIsContentVisible] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setIsContentVisible(false));

    const switchProfile = () => {
        setIsContentVisible(!isSwitchProfile);
    };

    const router = useRouter();
    const pathname = usePathname();

    const { data: session } = useSession();
    const isAdmin = session?.role?.includes('admin');
    const isRM = session?.role?.includes('resource_manager');
    const isAdminOrRm = isAdmin || isRM;
    const isManager = session?.gradeLevel === 'manager' && !isAdminOrRm;
    const isPartner = session?.gradeLevel === 'partner' && !isAdminOrRm;
    const isDelegate = session?.isDelegate;
    const args = HeaderArguments(router, pathname, session, setShowEdit, switchProfile);
    if (!session) { return <></> }


    return (
        <div className="min-h-screen pt-12">
            <div className="fixed top-0 left-0 w-full z-[997]">
                {session && <Header {...args} />}
            </div>
            <GuestRM
                show={showEdit === "GuestRMView"}
                onClose={() => {
                    setShowEdit("");
                }}
            />
            <Notifications
                show={showEdit === "notification"}
                setDrawer={setShowEdit}
                onClose={() => {
                    setShowEdit("");
                }}
            />
            {
                showEdit === "LoginBehalf" &&
                <LoginBehalf
                    show={true}
                    onClose={() => {
                        setShowEdit("");
                    }}
                />
            }
            {
                !session?.isDelegate && showEdit === 'Delegates' && (
                    <Delegates
                        onClose={() => setShowEdit("")}
                    />
                )
            }
            {((isDelegate && args.delegateTypes.includes('all')) || !isDelegate) && (
                <SwitchProfile
                    active="manager"
                    session={session}
                    onClose={() => setShowEdit("")}
                />
            )}
            <DelegateActivity
                show={showEdit === "DelegateActivity"}
                onClose={() => {
                    setShowEdit("");
                }}
            />
            <LayoutMainContainer children={children} />
        </div >
    );
};

UserLayout.propTypes = {
    children: PropTypes.node,
};
export default UserLayout;